import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_COMPTEA_SCHEMA_LITERAL = {
    title: 'Schéma CompteA',
    description: 'Décrit une section A',
    version: 2,
    keyCompression: false,
    //primaryKey: 'CA_NUM',
    primaryKey: { key : 'CA_NUM_PK', fields : ['N_ANALYTIQUE', 'CA_NUM'], separator : '_' },
    type: 'object',
    properties: {
        CA_NUM_PK: { type: 'string', maxLength: 40 },
        CA_NUM: { type: 'string', maxLength: 40 },
        CA_INTITULE: { type: 'string' },
        CA_LIB: { type: 'string', default: '' },
        N_ANALYTIQUE: { type: 'number' },
        N_ANALYTIQUELIB: { type: 'string' },
        IS_AFFAIRE: { type: ['number', 'null'] }
    },
    required: [ 'CA_NUM', 'CA_INTITULE', 'CA_LIB', 'N_ANALYTIQUE', 'N_ANALYTIQUELIB' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(F_COMPTEA_SCHEMA_LITERAL);
export type RxFCompteADocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_COMPTEA_SCHEMA: RxJsonSchema<RxFCompteADocumentType> = F_COMPTEA_SCHEMA_LITERAL;
